type DeliveryMergeFields = {
  trackingNumber?: string | null;
  destinationAddress?: string | null;
  deliveryTrackingHistories?: unknown;
};

export const mergeCardDeliveryInfo = <T extends DeliveryMergeFields | null | undefined>(primary: T, fallback: T): T => {
  if (primary == null) {
    return fallback;
  }
  if (fallback == null) {
    return primary;
  }

  return {
    ...fallback,
    ...primary,
    trackingNumber: primary.trackingNumber,
    destinationAddress: primary.destinationAddress ?? fallback.destinationAddress,
    deliveryTrackingHistories: primary.deliveryTrackingHistories ?? fallback.deliveryTrackingHistories,
  };
};

/** Prefer ESIA personal fields; fill card/delivery gaps from Profile+Applications decision. */
export const mergeEsiaWithServerRegInfo = <T extends object>(esiaRes: T, serverRegInfo: T): T => {
  const esia = esiaRes as T & {
    cardStatusId?: number;
    cardApplicationStatusId?: number;
    cardDeliveryInfo?: DeliveryMergeFields | null;
  };
  const server = serverRegInfo as T & {
    cardStatusId?: number;
    cardApplicationStatusId?: number;
    cardDeliveryInfo?: DeliveryMergeFields | null;
  };

  return {
    ...esia,
    cardStatusId: server.cardStatusId ?? esia.cardStatusId,
    cardApplicationStatusId: esia.cardApplicationStatusId ?? server.cardApplicationStatusId,
    cardDeliveryInfo: mergeCardDeliveryInfo(esia.cardDeliveryInfo, server.cardDeliveryInfo),
  };
};
